import { render, staticRenderFns } from "./Starting.vue?vue&type=template&id=1d1eb5da&"
import script from "./Starting.vue?vue&type=script&lang=js&"
export * from "./Starting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports